/* eslint-disable no-param-reassign */
export default class ApplicationDataManager {
  static init(params) {
    return new ApplicationDataManager(params);
  }

  constructor(params) {
    const { application } = params;
    this.root = application.scene.root;
  }

  setData(data) {
    const { products, areas, mainData } = data;
    this.data = data;

    this.hotspots = this.root.findByTag('hotspot');
    if (this.hotspots) {
      this.hotspots.forEach((hotspot) => {
        hotspot.script.hotspot.setActiveByAPI(false);

        // Product hotspots
        if (hotspot.script.hotspot.postType === 0) {
          products.forEach((product) => {
            if (product.alias === hotspot.script.hotspot.alias) {
              hotspot.script.hotspot.title = product.productTitleText;
              hotspot.script.hotspot.setActiveByAPI(true);
              hotspot.script.hotspot.setIsFeatured(product.featured);
              hotspot.script.hotspot.setFeaturedLabel(
                mainData.overallApp.featuredLabelText
              );

              // console.log('products: ', product.alias);
            }
          });
        }

        // Area hotspots
        if (hotspot.script.hotspot.postType === 1) {
          areas.forEach((product) => {
            if (product.alias === hotspot.script.hotspot.alias) {
              hotspot.script.hotspot.title = product.areaTitleText;
              hotspot.script.hotspot.setActiveByAPI(true);
              hotspot.script.hotspot.setIsFeatured(product.featured);
              hotspot.script.hotspot.setFeaturedLabel(
                mainData.overallApp.featuredLabelText
              );
              // console.log('area: ', product.alias);
            }
          });
        }
      });
    }

    this.root.script.hotspotManager.collectHotspots();

    /**
     * Hide 3d products (tagged product) that don't exist in api data.
     */
    this.products = this.root.findByTag('product');
    this.products.forEach((product) => {
      product.enabled = false;
      products.forEach((apiProduct) => {
        if (apiProduct.alias === product.script.product.alias) {
          product.enabled = true;
        }
      });
      areas.forEach((apiProduct) => {
        if (apiProduct.alias === product.script.product.alias) {
          product.enabled = true;
        }
      });
    });

    const lang = document.querySelector('meta[name="geo.region"]');
    if (lang && lang.content.toLowerCase() === 'jp') {
      this.root.script.app.setLocale('ja-JP');
    }

    this.root.script.app.setDataSet();
    this.setDataLevelPhase2();
  }

  setDataLevelPhase2() {
    const roomData = this.data.mainData.rooms;

    // Room signs
    this.roomSigns = this.root.findByTag('room_sign_label');
    if (this.roomSigns) {
      this.roomSigns.forEach((sign) => {
        switch (sign.script.textSign.room) {
          case 0:
            sign.element.text = roomData.roomATitle.toUpperCase();
            break;
          case 1:
            sign.element.text = roomData.roomBTitle.toUpperCase();
            break;
          case 2:
            sign.element.text = roomData.roomCTitle.toUpperCase();
            break;
          case 3:
            sign.element.text = roomData.roomDTitle.toUpperCase();
            break;
          case 4:
            sign.element.text = roomData.roomETitle.toUpperCase();
            break;
          default:
            break;
        }
      });
    }
    // Map Overlays
    this.mapOverlays = this.root.findByTag('map_overlay');
    if (this.mapOverlays) {
      this.mapOverlays.forEach((overlay) => {
        overlay.children.forEach((child) => {
          if (child.name === 'room') {
            switch (overlay.script.mapOverlay.room) {
              case 0:
                child.element.text = roomData.roomATitle.toUpperCase();
                break;
              case 1:
                child.element.text = roomData.roomBTitle.toUpperCase();
                break;
              case 2:
                child.element.text = roomData.roomCTitle.toUpperCase();
                break;
              case 3:
                child.element.text = roomData.roomDTitle.toUpperCase();
                break;
              case 4:
                child.element.text = roomData.roomETitle.toUpperCase();
                break;
              default:
                break;
            }
          }
        });
      });
    }
  }
}
